import React from 'react';
import { useTranslation } from 'react-i18next';

const CosmetologyPage = ({ onButtonClick, onBack, onOpenRemoval, onOpenPhototherapy, onOpenVesselRemoval, onOpenSkinResurfacing }) => {
  const { t } = useTranslation();
  
  const cosmetologyServices = [
    { icon: 'tumor-removal.png', name: t('cosmetologyPage.services.removal'), price: '' },
    { icon: 'phototherapy.png', name: t('cosmetologyPage.services.phototherapy'), price: '' },
    { icon: 'vessel-removal.png', name: t('cosmetologyPage.services.vesselRemoval'), price: '' },
    { icon: 'skin-resurfacing.png', name: t('cosmetologyPage.services.skinResurfacing'), price: '' },
    { icon: 'back.png', name: t('cosmetologyPage.services.back'), price: '' }
  ];

  const handleServiceClick = (serviceName) => {
    if (serviceName === t('cosmetologyPage.services.back')) {
      onBack();
    } else if (serviceName === t('cosmetologyPage.services.removal')) {
      onOpenRemoval();
    } else if (serviceName === t('cosmetologyPage.services.phototherapy')) {
      onOpenPhototherapy();
    } else if (serviceName === t('cosmetologyPage.services.vesselRemoval')) {
      onOpenVesselRemoval();
    } else if (serviceName === t('cosmetologyPage.services.skinResurfacing')) {
      onOpenSkinResurfacing();
    } else {
      onButtonClick(serviceName);
    }
  };

  return (
    <>
      <header className="header">
        <div className="clinic-logo">
          <div className="logo-icon">
            <img src="/icons/cosmetology.png" alt={t('cosmetologyPage.title')} width="40" height="40" />
          </div>
          <h1>{t('cosmetologyPage.title')}</h1>
        </div>
        
        <div className="user-greeting">
          <p>{t('cosmetologyPage.subtitle')}</p>
        </div>
      </header>

      <main className="main-content">
        <div className="welcome-section">
          <h2>{t('cosmetologyPage.welcome')}</h2>
          <p className="subtitle">{t('cosmetologyPage.chooseProcedure')}</p>
        </div>

        <div className="buttons-grid">
          {cosmetologyServices.map((service, index) => (
            <button 
              key={index}
              className={`service-btn ${service.name === t('cosmetologyPage.services.back') ? 'back-btn' : ''}`}
              onClick={() => handleServiceClick(service.name)}
            >
              <span className="btn-icon">
                <img 
                  src={`/icons/${service.icon}`} 
                  alt={service.name} 
                  width="30" 
                  height="30" 
                />
              </span>
              <div className="service-info">
                <span className="service-name">{service.name}</span>
              </div>
            </button>
          ))}
        </div>
      </main>

      <footer className="footer">
        <p>{t('cosmetologyPage.footer.main')}</p>
        <p className="footer-info">{t('cosmetologyPage.footer.info')}</p>
      </footer>
    </>
  );
};

export default CosmetologyPage;